import { PURCHASES_ERROR_CODE } from '@revenuecat/purchases-capacitor';

export class RevenueCatSDKPurchaseError extends Error {
    constructor({ message, cancelled = false, status, errorCode }: { message: string; cancelled?: boolean; status?: 400 | 500, errorCode?: string }){
        super(message);
        this.cancelled = cancelled;
        this.status = status || 500;
        this.errorCode = errorCode;
    }
    cancelled: boolean;
    status: 500 | 400 = 500;;
    errorType = 'RevenueCatSDKPurchaseError';
    errorCode?: string;
}

export class PurchasesErrorAdapter {

    // Codes are defined separately for web, but codes appear to line up,
    // so we're using this map for both
    private errorCodesToProps: {[code: string]: Partial<RevenueCatSDKPurchaseError>} = {
        // user clicked back
        [PURCHASES_ERROR_CODE.PURCHASE_CANCELLED_ERROR]: {
            status: 400,
            cancelled: true
        },
        // cc declined
        [PURCHASES_ERROR_CODE.PURCHASE_NOT_ALLOWED_ERROR]: {
            status: 400,
            cancelled: true
        }
    };

    convert = (error: any) => {
        const code = error?.code || error?.errorCode;

        if (code) {
            const overrides = this.errorCodesToProps[code] || {};

            throw new RevenueCatSDKPurchaseError({
                status: 500,
                message: error.message,
                ...overrides
            });
        }
        else  {
            throw new RevenueCatSDKPurchaseError({ message: JSON.stringify(error) });
        }
    };
}
